import clsx from 'clsx'
import React from 'react'
import styled from 'styled-components'

const TextPath = styled.path`
  &.dark-mode {
    fill: ${props => props.theme.palette.neutral.eight};
  }
  &.light-mode {
    fill: ${props => props.theme.palette.product.loyalty};
  }
`

const PlusPath = styled.path`
  fill: ${props => props.theme.palette.highlight.loyalty.normal};
`

interface Props extends React.SVGAttributes<SVGSVGElement> {
  colourMode?: 'dark' | 'light'
}

function LuxPlusLogo(props: Props) {
  const {
    colourMode = 'light',
    className,
    ...rest
  } = props
  return (
    <svg viewBox="0 0 74 10" {...rest}>
      <TextPath
        className={clsx(className, `${colourMode}-mode`)}
        d="M61.464 10c-.75 0-1.477-.106-2.18-.32-.695-.212-1.246-.495-1.653-.847l.625-1.402a5.06 5.06 0 0 0 1.458.777 5.506 5.506 0 0 0 1.75.292c.722 0 1.26-.116 1.611-.347.361-.232.542-.537.542-.917a.858.858 0 0 0-.306-.68 1.974 1.974 0 0 0-.75-.431 16.894 16.894 0 0 0-1.25-.347 14.978 14.978 0 0 1-1.805-.528 3.057 3.057 0 0 1-1.18-.82c-.325-.38-.487-.888-.487-1.527 0-.537.144-1.023.43-1.459.297-.444.737-.796 1.32-1.055C60.182.129 60.904 0 61.756 0c.592 0 1.175.074 1.75.222.574.148 1.07.361 1.486.64l-.57 1.402c-.426-.25-.87-.44-1.333-.57a4.987 4.987 0 0 0-1.347-.194c-.713 0-1.246.12-1.597.361-.343.24-.514.56-.514.958 0 .278.097.505.291.681.204.176.459.315.764.417.306.102.722.217 1.25.347.722.167 1.315.342 1.778.528.463.176.856.449 1.18.82.334.37.5.87.5 1.5 0 .536-.148 1.022-.444 1.457-.287.436-.727.783-1.32 1.042-.592.26-1.314.389-2.166.389Zm-10.07 0c-1.343 0-2.39-.375-3.14-1.125-.75-.76-1.124-1.843-1.124-3.25V.139h1.805v5.417c0 1.907.824 2.86 2.472 2.86 1.64 0 2.459-.953 2.459-2.86V.139h1.778v5.486c0 1.407-.375 2.49-1.125 3.25-.741.75-1.783 1.125-3.125 1.125ZM40.562.139h-1.805V9.86h6.889V8.333h-5.084V.14Zm-8.025 0c.842 0 1.574.139 2.194.417.63.277 1.111.675 1.445 1.194.333.519.5 1.134.5 1.847 0 .704-.167 1.32-.5 1.847-.334.519-.815.917-1.445 1.195-.62.278-1.352.417-2.194.417h-2.195V9.86h-1.805V.14h4Zm-.084 5.389c.787 0 1.385-.167 1.792-.5.408-.334.611-.81.611-1.43 0-.621-.203-1.098-.61-1.431-.408-.334-1.006-.5-1.793-.5h-2.11v3.86h2.11Zm-10.072.055 3.139 4.278h1.194l-3.708-5.028L26.45.14h-1.111L22.422 4.11 19.492.14h-1.18l3.457 4.722-3.694 5h1.18l3.126-4.278ZM12.197 9.944c-1.26 0-2.24-.36-2.945-1.083-.703-.722-1.055-1.773-1.055-3.153V.138h1.028v5.529c0 1.13.254 1.972.764 2.527.509.556 1.245.834 2.208.834.972 0 1.713-.278 2.222-.834.51-.555.764-1.398.764-2.527V.139h1v5.57c0 1.379-.352 2.43-1.056 3.152-.694.722-1.67 1.083-2.93 1.083ZM1.027.14H0V9.86h6.472v-.889H1.028V.14Z"
        clipRule="evenodd"
      />
      <PlusPath d="M73.662 5.694h-2.458v2.431h-1.486v-2.43H67.26v-1.39h2.458v-2.43h1.486v2.43h2.459v1.39Z" />
    </svg>
  )
}

export default LuxPlusLogo
